import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/logo.png';
import '../stylings/Navbar.css';

export default function Navbar() {
  const [sticky, setSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const sentinelRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setSticky(!entry.isIntersecting),
      { threshold: 0 }
    );
    if (sentinelRef.current) observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <div ref={sentinelRef} className="navbar-sentinel" />
      <nav className={`site-navbar${sticky ? ' navbar-sticky' : ''}`}>
        <div className="container-fluid px-4">
          <div className="navbar-inner">
            {sticky && (
              <Link to="/" className="navbar-sticky-logo" onClick={closeMenu}>
                <img src={logo} alt="Logo" />
              </Link>
            )}
            <button
              className={`navbar-toggler-btn${menuOpen ? ' open' : ''}`}
              onClick={() => setMenuOpen((p) => !p)}
              aria-label="Toggle menu"
            >
              <span></span><span></span><span></span>
            </button>
            <ul className={`navbar-menu${menuOpen ? ' menu-open' : ''}`}>
              <li><NavLink to="/" end onClick={closeMenu}>Home</NavLink></li>

              <li className="has-dropdown">
                <span>About Us <i className="fas fa-chevron-down fa-xs"></i></span>
                <ul className="dropdown-menu-custom">
                  <li><NavLink to="/about-school" onClick={closeMenu}>About School</NavLink></li>
                  <li><NavLink to="/principal-message" onClick={closeMenu}>Principal's Message</NavLink></li>
                  <li><NavLink to="/chairman-message" onClick={closeMenu}>Chairman's Message</NavLink></li>
                  <li><NavLink to="/manager-message" onClick={closeMenu}>Manager's Message</NavLink></li>
                </ul>
              </li>

              <li className="has-dropdown">
                <span>Academics <i className="fas fa-chevron-down fa-xs"></i></span>
                <ul className="dropdown-menu-custom">
                  <li><NavLink to="/academic-calendar" onClick={closeMenu}>Academic Calendar</NavLink></li>
                  <li><NavLink to="/syllabus" onClick={closeMenu}>Syllabus</NavLink></li>
                  <li><NavLink to="/time-table" onClick={closeMenu}>Time Table</NavLink></li>
                </ul>
              </li>

              <li className="has-dropdown">
                <span>Gallery <i className="fas fa-chevron-down fa-xs"></i></span>
                <ul className="dropdown-menu-custom">
                  <li><NavLink to="/galleryall" onClick={closeMenu}>Photo Gallery</NavLink></li>
                  <li><NavLink to="/videoall" onClick={closeMenu}>Video Gallery</NavLink></li>
                </ul>
              </li>

              <li><NavLink to="/cbse-mandatory-public-disclosure" onClick={closeMenu}>Mandatory Public Disclosure</NavLink></li>

              <li><NavLink to="/noticeall" onClick={closeMenu}>Notices</NavLink></li>
              <li><NavLink to="/contact" onClick={closeMenu}>Contact Us</NavLink></li>
              <li>
                <NavLink to="/login" className="nav-erp-btn" onClick={closeMenu}>
                  ERP Login
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
